module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fp8ar"))).then(() => parcelRequire('iDabs'));